<template>
    <div class="flex">
        <a href="#" title="Notifications" class="text-base p-4 flex hover:text-yellow-200 text-white"
           @click.prevent="openIt()">
            <i class="fas fa-bell"></i>
        </a>
        <span v-if="notificationCount > 0"
              class="absolute ml-6 items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-600 text-white">
          {{ notificationCount }}
        </span>
        <slideover name="notifications" ref="slideover" v-if="typeof user === 'object'"
                   :content-class="'mt-1 px-6 overflow-y-auto h-full'">
            <template v-slot:title>
                <div class="flex h-10">
                    <div class="-mt-1.5 -ml-2">
                        <div class="inline-block text-gray-800 mt-0 pt-1 pb-0.5 px-2">Notifications</div>
                        <span class="text-gray-300 text-sm mt-0 ml-2"><span
                            class="far fa-keyboard mr-1"></span>N</span>
                    </div>
                </div>
            </template>
            <template>
                <div :key="key">
                    <div v-if="!items.length">
                        <div class="text-lg justify-center items-center my-2">
                            You have no notifications.
                        </div>
                    </div>
                    <div v-if="unread.length"
                         class="pl-1 border-b border-gray-200 text-brand bg-white font-semibold text-lg h-10 flex items-center sticky sticky-top top-0 z-20">
                        <div class="flex-grow">Unread Notifications</div>
                        <div
                            class="pl-l mt-1 border-gray-200 border rounded text-gray-500 hover:text-brand text-xs py-0.5 px-1.5 bg-white hover:bg-gray-50 font-medium cursor-pointer"
                            @click="markAllRead">
                            <span class="mx-px my-0.5 text-xs">Mark all as read</span>
                        </div>
                    </div>
                    <ul class="flex-1 divide-y divide-gray-200 overflow-none" v-if="unread.length">
                        <li v-for="item in unread" :key="item.id">
                            <div class="my-3 mx-1 text-gray-700">
                                <div class="text-sm my-1 notification-widget-message-container"
                                     v-html="item.text"></div>
                                <div class="flex truncate items-baseline text-xs">
                                    <span class="font-semibold mr-0.5">Received at:</span>
                                    <span class="truncate" v-text="formatDate(item.raisedAt)"></span>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div v-if="read.length"
                         class="pl-1 border-b border-gray-200 text-brand bg-white font-semibold text-lg h-10 flex items-center sticky sticky-top top-0 z-20">
                        <div class="flex-grow">Read Notifications</div>
                    </div>
                    <ul class="flex-1 divide-y divide-gray-200 overflow-none" v-if="read.length">
                        <li v-for="item in read" :key="item.id">
                            <div class="my-3 mx-1 text-gray-700 opacity-50">
                                <div class="text-sm my-1 notification-widget-message-container"
                                     v-html="item.text"></div>
                                <div class="flex truncate items-baseline text-xs">
                                    <span class="font-semibold mr-0.5">Received at:</span>
                                    <span class="truncate" v-text="formatDate(item.raisedAt)"></span>
                                </div>
                                <div class="flex truncate items-baseline text-xs">
                                    <span class="font-semibold mr-0.5">Read at:</span>
                                    <span class="truncate" v-text="formatDate(item.readAt)"></span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </template>
        </slideover>
    </div>
</template>

<script>


import User from "../../../services/User";
import moment from "moment-timezone";
import {Notification} from "@models";

export default {
    components: {},
    props: {},
    data() {
        return {
            user: null,
            items: [],
            key: 0,
            notificationCount: 0,
        }
    },
    computed: {
        unread() {
            return this.items.filter((i) => !i.readAt).sort((a, b) => {
                return moment(b.raisedAt).valueOf() - moment(a.raisedAt).valueOf()
            });
        },
        read() {
            return this.items.filter((i) => i.readAt).sort((a, b) => {
                return moment(b.raisedAt).valueOf() - moment(a.raisedAt).valueOf()
            });
        },
    },
    methods: {
        close() {
            if (!this.hidden) {
                this.hidden = true;
                eventBus.$emit('slideover-close-notifications');
            }
        },
        async openIt(data) {
            this.updateNotification()
            window.Bus.emit('close-all-slideovers', '-notifications');
            eventBus.$emit('slideover-open-notifications');
            this.hidden = false;
        },
        updateFromListener(data) {
            if (this.hidden) {
                data.data.notifications.filter((i) => {
                    return !i.readAt && !this.user.notifications.some((ni) => ni.id === i.id)
                }).forEach((m) => {
                    Notifications.bell('Notification received', m.text)
                })
            }
            this.user.notifications = data.data.notifications
            this.updateNotification()
        },
        formatDate(due) {
            let d = moment(due)
            return d.format('MMMM Do, YYYY [at] hh:mmA')
        },
        async updateNotification() {
            this.user = User.user
            this.items = this.user.notifications
            this.notificationCount = this.unread.length
            window.Bus.emit('notifications-unread', this.notificationCount);
            this.key++
        },
        async markAllRead() {
            await Notification.markRead(this.unread.map((i) => i.id));
        }
    },
    async mounted() {
        eventBus.$emit('slideover-set-scrollable-notifications', false);
        await User.register()
        User.registerAggregate({
            'type': 'User',
            'id': User.user.id,
            'event': 'NotificationsUpdated'
        }, this.updateFromListener)
        this.user = User.user;

        await this.updateNotification()

        window.Bus.on('close-all-slideovers', (e) => {
            if (e !== '-notifications') {
                this.close()
            }
        })

        eventBus.$on('slideover-opened', (e) => {
            if (e !== '-notifications') {
                this.close()
            }
        })

        eventBus.$on('slideover-closed', (e) => {
            if (e === '-notifications') {
                this.close()
            }
        })

        window.Bus.on('show-package-filesystem', () => {
            this.close()
            this.disabledOpening = true;
        });

        window.Bus.on('close-package-filesystem', () => {
            this.disabledOpening = false;
        });

        window.Bus.on('open-notifications', (data) => {
            this.openIt(data)
        });

        window.addEventListener('keydown', (e) => {
            if (e.ctrlKey || e.metaKey) {
                return;
            }
            if (e.keyCode === 27) {
                this.close()
                return
            }
            if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(e.target.tagName)) {
                return;
            }
            if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(document.activeElement.tagName)) {
                return;
            }

            if (!this.disabledOpening) {
                if ((e.key === 'n') || (e.key === 'N')) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (this.hidden) {
                        this.openIt()
                    } else {
                        this.close()
                    }
                }
            }
        })
        window.Bus.emit('notification-widget-loaded');
        window.Bus.emit('notifications-unread', this.notificationCount);
    }
}
</script>

<style lang="css">
.notification-widget-message-container a {
    color: #0088CE !important;
    font-weight: bold;
}

.notification-widget-message-container a:hover {
    text-decoration: underline;
}
</style>
